import React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ChevronLeft } from 'lucide-react';
import CreateDCQForm from './CreateDCQForm';
import useCreateDCQForm from './useCreateDCQForm';

function CreateDCQ() {
  const { participantID } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const formProps = useCreateDCQForm({ participantID, navigate, location });

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
          className="mb-6"
        >
          <button
            onClick={() => navigate(-1)}
            className="group flex items-center text-primary-600 hover:text-primary-700 transition-colors duration-200"
          >
            <ChevronLeft className="w-5 h-5 mr-1 group-hover:transform group-hover:-translate-x-1 transition-transform duration-200" />           
            <span className="font-medium">Back</span>
          </button>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
          className="bg-white dark:bg-gray-800 rounded-lg shadow-md dark:shadow-gray-900/20 overflow-hidden"
        >
          <div className="px-6 py-5 bg-primary-600">
            <h2 className="text-xl font-semibold text-white">Create New DCQ</h2>
            <p className="text-primary-100 text-sm mt-1">Fill out the form below to create a new Data Clarification Query</p>
          </div>
          <div className="px-6 py-8 sm:p-8">
            <CreateDCQForm {...formProps} />
          </div>
        </motion.div>
      </div>
    </div>
  );
}

export default CreateDCQ;